export const formatCurrencyBr = (value: number | undefined) => {
  if(value) {
    var f = value.toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
    return f;
  } else if (value === 0){
    return '-';
  }
}
